import { ApplicationError } from '../application-error';

export class UserNotFoundError extends ApplicationError {
  public override readonly name: string;

  constructor(message: string) {
    super(message);
    this.name = 'UserNotFoundError';
  }
}
